import { Component, input } from '@angular/core';

import { AlertType } from '../../models/alert-type';
import { AlertComponent } from './alert.component';

// <app-alert-warning> - an app-alert whose type is warning, so a template need not pass the type as
// a string (Chris, PR 2581). It still takes a type, as app-alert does.
@Component({
  selector: 'app-alert-warning',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertWarningComponent extends AlertComponent {
  public override readonly type = input<AlertType>('warning');
}
